<!--
  vivest-modal (design system): título no atributo heading; condições e mensagem no slot
  "description" (o modal não tem slot de conteúdo livre); botões no slot "actions".
-->
<vivest-modal
  [heading]="titulo()"
  [hasIcon]="false"
  open
  dismissible
  (vivest-close)="fechar.emit()"
  data-testid="regra-modal"
>
  <div slot="description" class="regra-modal">
    <fieldset class="regra-modal__grupo" aria-describedby="regra-modal-condicoes-dica">
      <legend class="regra-modal__rotulo">
        Condições de elegibilidade<span class="regra-modal__obrigatorio" aria-hidden="true">*</span>
      </legend>
      <p id="regra-modal-condicoes-dica" class="regra-modal__dica">
        O participante só terá o instituto se atender a todas as condições marcadas.
      </p>
      <ul class="regra-modal__condicoes">
        @for (opcao of opcoes(); track opcao.value) {
          <li>
            <vivest-checkbox
              label-variant="multi-line"
              name="regra-condicoes"
              [value]="opcao.value"
              [checked]="marcada(opcao)"
              (change)="alternar(opcao, $any($event.target).checked)"
              [attr.data-testid]="'regra-modal-condicao-' + opcao.value"
            >
              {{ opcao.label }}
            </vivest-checkbox>

            <!-- Condição parametrizável marcada: o valor é lido como frase ("Mínimo de [ 3 ] anos…"). -->
            @if (opcao.parametro; as parametro) {
              @if (marcada(opcao)) {
                <div class="regra-modal__parametro">
                  <label class="regra-modal__parametro-frase" [for]="'regra-modal-valor-' + opcao.value">
                    <span>{{ parametro.prefixo }}</span>
                    <input
                      #campoValor
                      [id]="'regra-modal-valor-' + opcao.value"
                      class="form-control regra-modal__valor"
                      type="text"
                      inputmode="numeric"
                      autocomplete="off"
                      [attr.maxlength]="parametro.maximo.toString().length"
                      required
                      [attr.aria-label]="parametro.rotulo"
                      [attr.aria-invalid]="tentouSalvar() && errosValor().has(opcao.value)"
                      [attr.aria-describedby]="tentouSalvar() && errosValor().has(opcao.value) ? 'regra-modal-valor-erro-' + opcao.value : null"
                      [class.is-invalid]="tentouSalvar() && errosValor().has(opcao.value)"
                      [value]="valor(opcao)"
                      (input)="digitarValor(opcao, campoValor)"
                      [attr.data-testid]="'regra-modal-valor-' + opcao.value"
                    />
                    <span>{{ parametro.sufixo }}</span>
                  </label>
                  @if (tentouSalvar() && errosValor().get(opcao.value); as erro) {
                    <p [id]="'regra-modal-valor-erro-' + opcao.value" class="regra-modal__erro" role="alert">{{ erro }}</p>
                  }
                </div>
              }
            }
          </li>
        }
      </ul>
      @if (tentouSalvar() && semCondicao()) {
        <p class="regra-modal__erro" role="alert" data-testid="regra-modal-erro">
          Marque ao menos uma condição.
        </p>
      }
    </fieldset>

    <div class="regra-modal__grupo">
      <label class="regra-modal__rotulo" for="regra-modal-mensagem">Mensagem de não elegibilidade (opcional)</label>
      <textarea
        id="regra-modal-mensagem"
        class="form-control regra-modal__textarea"
        rows="3"
        placeholder="Ex.: A opção de Portabilidade não está disponível porque…"
        [attr.maxlength]="mensagemMaximo"
        [value]="mensagem()"
        (input)="mensagem.set($any($event.target).value)"
        aria-describedby="regra-modal-mensagem-dica"
        data-testid="regra-modal-mensagem"
      ></textarea>
      <p id="regra-modal-mensagem-dica" class="regra-modal__dica regra-modal__contador">
        <span>Exibida ao participante quando o instituto está habilitado e ele não atende à regra.</span>
        <span>{{ mensagem().length }}/{{ mensagemMaximo }}</span>
      </p>
    </div>
  </div>

  <vivest-button slot="actions" variant="outline" size="md" data-testid="regra-modal-cancelar" (click)="fechar.emit()">
    Cancelar
  </vivest-button>
  <vivest-button slot="actions" variant="primary" size="md" data-testid="regra-modal-salvar" (click)="confirmar()">
    {{ regra() ? 'Salvar regra' : 'Adicionar regra' }}
  </vivest-button>
</vivest-modal>
